/* eslint-disable */
import {ElMessage, ElMessageBox} from 'element-plus'
import {saveAs} from 'file-saver'
import vuex from "@/store";
import router from "@/router";

// 是否开启mock数据 true:开启 false:关闭 (在开发环境下可以为true或false，在生产/测试环境下只能为false)
const IS_MOCK_DATA = process.env.VUE_APP_BASE_API === '/dev-api' && false;
const MOCK_URL = "https://mock.apipost.net/mock/2eba83/";
// 需要mock的接口数组，格式：[真实接口1, 真实接口2, 真实接口3（show/videoGenerateDub/generate）]
// 当数组为空时，且mock控制器为true则所有经过此方法的接口都走mock数据。
// 当数组不为空时，且mock控制器为true则只有数组里面的接口走mock数据，其他接口走真实接口。
const IS_MOCK_ARRAY_LIST = [
    'show/property/taskRegenerate',
];


/**
 * @author: kxf
 * @createDate: 2025/4/18
 * @description: 1.mock控制器为true时，请求地址使用mock地址 例子：https://mock.apipost.net/mock/2eba83/show/videoGenerateDub/generate?apipost_id=3a688ccb700009
 * @description: 2.mock控制器为false时，判断parameterObj有无参数，没有参数，直接把真实接口（show/videoGenerateDub/generate）截出来并return出去，
 * @description: 2.mock控制器为false时，判断parameterObj有无参数，有参数，把真实接口（show/videoGenerateDub/generate）截出来添加parameterObj参数并return出去，
 * 入参解释:
 * @param {*} url: "show/videoGenerateDub/generate?apipost_id=3a688ccb700009"
 * @param {*} parameterObj: {apipost_id: "3a688ccb700009"}
 * 返回值解释:
 * @steps：
 */
$define("mockDataMiddleware", (url, parameterObj = {}) => {
    let mockUrl = MOCK_URL + url;
    let realUrl = url.split("?")[0];
    if (IS_MOCK_DATA && !IS_MOCK_ARRAY_LIST.length) return mockUrl;
    if (IS_MOCK_DATA && IS_MOCK_ARRAY_LIST.length && IS_MOCK_ARRAY_LIST.includes(realUrl)) return mockUrl;

    if (!Object.keys(parameterObj).length) return realUrl;
    return $stitchingPath(realUrl, parameterObj);
})


const accessTokenName = "accessToken";
const refreshTokenName = "refreshToken";
window.$define('setAccessToken', (accessToken) => {
    localStorage.setItem(accessTokenName, accessToken);
})

window.$define('setRefreshToken', (refreshToken) => {
    localStorage.setItem(refreshTokenName, refreshToken);

})

window.$define('getAccessToken', () => {
    return localStorage.getItem(accessTokenName);
})

window.$define('getRefreshToken', () => {
    return localStorage.getItem(refreshTokenName);
})

window.$define('removeAccessToken', () => {
    return localStorage.removeItem(accessTokenName);
})

window.$define('removeRefreshToken', () => {
    return localStorage.removeItem(refreshTokenName);
})

/**
 * @author: lys
 * @createDate: 2025/7/25
 * @description: 需要禁用右键菜单的工具调用
 * 入参解释:
 * 返回值解释:
 * @steps：
 */
window.$define('disableRightClickMenu', () => {
    document.addEventListener('contextmenu', handleContextMenu);
})

const handleContextMenu = function (event) {
    // 阻止默认右键菜单行为
    event.preventDefault();
}
/**
 * @author: wzj
 * @createDate: 2025/11/10
 * @description: 获取视频的Blob URL并返回
 * 入参解释:
 * 返回值解释:
 * @steps：
 */
window.$define("downloadVolcanoVideo", async (videoUrl) => {
    try {
        // 1. 使用fetch下载视频，配置no-referrer
        const response = await fetch(videoUrl, {
            referrerPolicy: 'no-referrer'
        });
        // 2. 转换为Blob
        const videoBlob = await response.blob();
        // 3. 生成Blob URL并返回
        const blobUrl = URL.createObjectURL(videoBlob);
        return blobUrl;
    } catch (error) {
        console.error('视频下载失败:', error);
        throw error;
    }
})
/**
 * @author: lys
 * @createDate: 2025/7/25
 * @description: 禁用右键菜单的工具销毁前调用解禁方法
 * 入参解释:
 * 返回值解释:
 * @steps：
 */
window.$define('unlockRightClickMenu', () => {
    document.removeEventListener('contextmenu', handleContextMenu);
})
/**
 * @author: wzj
 * @createDate: 2025/4/8
 * @description: 秒数时间转换成分
 * 入参解释:
 *  @param {number} seconds - 总秒数
 *  @param {boolean} showHours - 是否显示小时位
 *  @returns {string} 格式化后的时间字符串
 * 返回值解释:
 * @steps：
 */
window.$define("formatDuration", function formatDuration(seconds, showHours = false) {
    if (isNaN(seconds) || seconds < 0) return showHours ? '00:00:00' : '00:00'

    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const secs = Math.floor(seconds % 60)

    const parts = []
    if (showHours || hours > 0) {
        parts.push(String(hours).padStart(2, '0'))
    }
    parts.push(String(minutes).padStart(2, '0'))
    parts.push(String(secs).padStart(2, '0'))

    return parts.join(':')
})
/**
 * @author: wzj
 * @createDate: 2025/4/30
 * @description: 音频映射文本
 * 入参解释:
 * 返回值解释:
 * @steps：
 */
window.$define("audioMappingText", (options, keyField, valueField) => {
        return options.reduce((map, option) => {
            map[option[keyField]] = option[valueField];
            return map;
        }, {});
    }
)
/**
 * @author: wzj
 * @createDate: 2025/7/29
 * @description: 年-月-日 时-分-秒格式化
 * 入参解释:
 * 返回值解释:
 * @steps：
 */
window.$define("formatDateTime", function formatDateTime(date = new Date()) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
})

/**
 * @author: wzj
 * @createDate: 2025/4/9
 * @description: 年月日时分秒格式化
 * 入参解释:
 * 返回值解释:
 * @steps：
 */
window.$define("flexFormatTimestamp", function flexFormatTimestamp(ts) {
    if (typeof ts !== 'string' || !/^\d+$/.test(ts)) return 'Invalid timestamp';

    const parts = [];
    let remaining = ts;

    // 按优先级处理时间部分
    const patterns = [
        {len: 4, sep: '-'},   // 年
        {len: 2, sep: '-'},   // 月
        {len: 2, sep: ' '},   // 日
        {len: 2, sep: ':'},   // 时
        {len: 2, sep: ':'},   // 分
        {len: 2, sep: ''}     // 秒
    ];

    for (const pattern of patterns) {
        if (remaining.length < pattern.len) break;

        parts.push(remaining.substring(0, pattern.len));
        remaining = remaining.slice(pattern.len);
        if (pattern.sep && remaining.length > 0) {
            parts.push(pattern.sep);
        }
    }

    // 拼接剩余字符（如果有）
    if (remaining.length > 0) {
        parts.push(remaining);
    }

    return parts.join('');
})
/**
 * @author: wzj
 * @createDate: 2025/7/30
 * @description: 随机数组
 * 入参解释:
 * 返回值解释:
 * @steps：
 */
window.$define('getRandomNumber', function getRandomNumber() {
    const rand = crypto.getRandomValues(new Uint32Array(2));
    return rand[0].toString() + rand[1].toString();
},)
/**
 * @author: wzj
 * @createDate: 2025/5/7
 * @description: 空间大小单位格式转化 第一个参数为传递过来的字节数，第二个参数为返回类型，返回类型为true时返回数字，返回类型为false时返回带单位的字符串
 * 入参解释:
 * 返回值解释:
 * @steps：
 */
window.$define("formatBytes", function formatBytes(bytes, returnNumber = false) {
    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
    let unitIndex = 0;

    while (bytes >= 1024 && unitIndex < units.length - 1) {
        bytes /= 1024;
        unitIndex++;
    }

    // 新增返回类型判断 ↓↓↓
    if (returnNumber) {
        return unitIndex === 0 ?
            bytes :
            parseFloat((Math.ceil(bytes * 10) / 10).toFixed(1));
    }

    return unitIndex === 0 ?
        `${bytes}${units[unitIndex]}` :
        `${(Math.ceil(bytes * 10) / 10).toFixed(1)}${units[unitIndex]}`;
})


/**
 * @author: kxf
 * @createDate: 2024/12/11
 * @description: 清除用户登录数据
 * 入参解释:
 * 返回值解释:
 * @steps：
 */
window.$define("clearUserInfoLoginData", () => {

})

/**
 * @author: kxf
 * @createDate: 2024/12/2
 * @description: 封装路由方法，在一些有特殊需求页面的页面里面跳转，需调用这个方法
 * 入参解释:
 * 返回值解释:
 * @steps：
 */
window.$define("encapsulatedRouting", (that, path) => {
    const routerPath = ["/queryRecharge"];
    if (routerPath.includes(that.$route.path)) {
        return that.$router.replace(path);
    }
    that.$router.push(path)
})

/**
 * @author: kxf
 * @createDate: 2024/8/28
 * @description: 检验文件大小是否合规
 * 入参解释:
 * @param {Buffer} file 文件流（字节单位）
 * @param {number} size 大小（兆单位）
 * 返回值解释:
 * @returns {boolean} 是否合规，false表示合规,true表示不合规
 * @steps：
 */
window.$define("verifyFileSize", (file, size) => {
    console.log("上传文件大小（单位/字节）：" + file.size);
    return (file.size / 1024 / 1024) > size;
})

//将远程图片地址转换为本地图片地址
window.$define("convertToLocalImgAddress", async function (imageUrl) {
    try {
        // 1. 通过 Fetch API 获取图片资源
        const response = await fetch(window.$convertToSameProtocol(imageUrl));
        // 2. 将响应数据转为 Blob 对象
        const blob = await response.blob();
        // 3. 返回 Blob（可根据需求进一步处理）
        return URL.createObjectURL(blob);
    } catch (error) {
        console.error('转换失败:', error);
        return imageUrl;
    }
})

//统一链接协议地址与网站域名协议相同
window.$define("convertToSameProtocol", function (link) {
    if (!link) return link;
    if (!(link.includes('http://') || link.includes('https://'))) return link;
    try {
        // 1. 获取当前网站的协议
        const currentProtocol = window.location.protocol;
        // 2. 创建一个链接对象，解析输入的链接
        const url = new URL(link);
        // 3. 判断输入的链接协议与当前网站协议是否一致
        if (url.protocol !== currentProtocol) {
            // 如果不同，更新协议为当前网站的协议
            url.protocol = currentProtocol;
        }
        // 4. 返回处理后的链接
        return url.toString();
    } catch (error) {
        console.error('链接处理失败:', error);
        return link;
    }
});

/**
 * @param {*} fn 要执行的函数
 * @param {*} interval 时间间隔
 * @returns
 */
window.$define("throttle", function (fn, interval) {

    // 1.记录上一次的开始时间
    let lastTime = 0

    // 2.事件触发时, 真正执行的函数
    const _throttle = function () {

        // 2.1.获取当前事件触发时的时间
        const nowTime = new Date().getTime()

        // 2.2.使用当前触发的时间和之前的时间间隔以及上一次开始的时间, 计算出还剩余多长时间需要去触发函数
        const remainTime = interval - (nowTime - lastTime)
        //第一次会执行，原因是nowTime刚开始是一个很大的数字，结果为负数
        //若最后一次没能满足条件，不会执行
        if (remainTime <= 0) {
            // 2.3.真正触发函数
            fn()
            // 2.4.保留上次触发的时间
            lastTime = nowTime
        }
    }
    return _throttle
})

window.$define("promise", (fn) => {
    return new Promise((resolve, reject) => {
        try {
            fn(resolve)
        } catch (e) {
            console.log(this, e, "promise里面出现错误了")
            reject(e);
        }
        ;
    });
});

// 往缓存里面存数据 localStorage
window.$define("localStorageSetItem", function (name = '', data) {
    if (!name) return false
    window.localStorage.setItem(name, data)
})

// 从缓存里取数据 localStorage
window.$define("localStorageGetItem", function (name = '') {
    if (!name) return false
    return window.localStorage.getItem(name) || null
})

// 删除缓存里的数据 localStorage
window.$define("localStorageRemoveItem", function (name = '') {
    if (!name) {
        window.localStorage.clear()
        return false
    }
    window.localStorage.removeItem(name);
})

// 往缓存里面存数据 SessionStorage
window.$define("localSessionStorageSetItem", function (name = '', data) {
    if (!name) return false
    window.sessionStorage.setItem(name, data)
})

// 从缓存里取数据 SessionStorage
window.$define("localSessionStorageGetItem", function (name = '') {
    if (!name) return false
    return window.sessionStorage.getItem(name) || null
})

// 删除缓存里的数据 SessionStorage
window.$define("localSessionStorageRemoveItem", function (name = '') {
    if (!name) {
        window.sessionStorage.clear()
        return false
    }
    window.sessionStorage.removeItem(name);
})

// new formdata
window.$define("newFormdata", function (data) {
    if (!data) {
        return null;
    }
    const formdata = new FormData()
    for (const key in data) {
        formdata.append(key, data[key])
    }
    return formdata;
})

window.$define("mutatorMethod", function (that) {
    let list = [];
    let breadcrumb = that.$route.matched.filter((item) => {
        return Object.keys(item.meta).length;
    })
    breadcrumb.forEach((item) => {
        let nameList = filterNull(item.meta.crumbs.split(","));
        let pathList = filterNull(item.path.split("/"));
        if (nameList.length == 1 && pathList.length == 1) {
            list.push({
                name: nameList[0],
                path: '/' + nameList[0]
            })
        } else {
            nameList.forEach((item, index) => {
                let path = '';
                for (let i = 0; i <= (index + 1); i++) {
                    path += pathList[i] + '/';
                }
                list.push({
                    name: nameList[index],
                    path: '/' + path,
                })
            })
        }
    })
    that.breadcrumb = list;

    function filterNull(item) {
        return item.filter(item => {
            return item;
        })
    }
})

window.$define("blobValidate", async function blobValidate(data) {
    try {
        const text = await data.text();
        JSON.parse(text);
        return false;
    } catch (error) {
        return true;
    }
})

window.$define("saveAsMethod", function saveAsMethod(res, name) {
    const blob = new Blob([res])
    saveAs(blob, name)
})


window.$define("deepCopy", function (obj) {
    // 只拷贝对象
    if (typeof obj !== 'object') return;
    // 根据obj的类型判断是新建一个数组还是一个对象
    var newObj = obj instanceof Array ? [] : {};
    for (var key in obj) {
        // 遍历obj,并且判断是obj的属性才拷贝
        if (obj.hasOwnProperty(key)) {
            // 判断属性值的类型，如果是对象递归调用深拷贝
            // @ts-ignore
            newObj[key] = typeof obj[key] === 'object' ? window.$deepCopy(obj[key]) : obj[key];
        }
    }
    return newObj;
})
window.$define("deepCopyString", function (obj) {
    return JSON.parse(JSON.stringify(obj));
})

// 拼接路径
window.$define("stitchingPath", function (url, params) {
    let str = ''
    if (typeof params === 'string') {
        url = url.indexOf('?') < 0 ? url + '?' : url
        return indexOfFn(url, params)
    } else {
        for (const key in params) {
            str += `&${key}=${params[key] || ''}`
        }
    }
    return indexOfFn(url, str)
})

// 错误弹框
window.$define("error", function (val) {
    ElMessage.error(val);
})

// 成功弹框
window.$define("success", function (val) {
    ElMessage.success(val);
})

// 取消 确定弹框
window.$define("messageBoxOpen", function (data, fn) {
    let obj = {
        title: '是否确认',
        leftTitle: '提示',
        state: "success",
        forbid: false,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        cancelButtonFnText: '成功取消',
        successFn: () => {
            // @ts-ignore
            fn && fn(data.parameter)
        },
        failFn: () => {
            if (obj.forbid) return;
            window.$success(obj.cancelButtonFnText)
        }
    }
    const boxData = Object.assign(obj, data)

    ElMessageBox.confirm(boxData.title, boxData.leftTitle, {
        confirmButtonText: boxData.confirmButtonText,
        cancelButtonText: boxData.cancelButtonText,
        type: boxData.state,
    }).then(() => {
        ElMessage({
            type: 'success',
            message: 'Delete completed',
        })
    })
        .catch(() => {
            ElMessage({
                type: 'info',
                message: 'Delete canceled',
            })
        })
})

// 下载 压缩包
window.$define("downloadURL", function () {
    let count = 0
    return (src) => {
        var hiddenIFrameID = 'hiddenDownloader' + count++
        var iframe = document.createElement('iframe')
        iframe.id = hiddenIFrameID
        iframe.style.display = 'none'
        document.body.appendChild(iframe)
        iframe.src = src
    }
})

// 浏览器下载 mp4
window.$define("handleDownload", function (link, fileName) {
    let x = new XMLHttpRequest()
    x.open('GET',link, true)
    x.responseType = 'blob'
    // eslint-disable-next-line
    x.onload = (e) => {
        let url = window.URL.createObjectURL(x.response)
        let a = document.createElement('a')
        a.href = url

        // @ts-ignore
        a.download = !fileName ? link.split("?")[0].split("/").at(-1) : fileName
        a.click()
    }
    // 新增下载完成监听
    x.onloadend = () => {
        // window.$success('下載成功')
    }

    x.send()
})

// 返回时间戳工具下载命名
window.$define("toolTimestampNaming", function (prefix, suffix) {
    // 获取当前日期
    const now = new Date();
    // 格式化日期，生成yyyyMMdd
    const date = now.getFullYear() +
        (now.getMonth() + 1).toString().padStart(2, '0') +
        now.getDate().toString().padStart(2, '0');
    // 格式化时间，生成HHmmss
    const time = now.getHours().toString().padStart(2, '0') +
        now.getMinutes().toString().padStart(2, '0') +
        now.getSeconds().toString().padStart(2, '0');
    // 拼接并返回结果
    return `${prefix}_${date}_${time}.${suffix}`;
})
/**
 * @author: wzj
 * @createDate: 2025/5/12
 * @description: 下载压缩包 流式文件 blob:response响应对象  flag：展示下载成功弹框
 * 入参解释:
 * 返回值解释:
 * @steps：
 */
window.$define("downloadZip", function (response, flag = false) {
    // 从 content-disposition 提取文件名
    const disposition = response.headers['content-disposition'];
    const filenameRegex = /filename=(.+)/;
    const matches = disposition.match(filenameRegex);
    let fileName;
    if (matches && matches[1]) {
        fileName = decodeURIComponent(matches[1]); // 解码可能存在的URL编码
    } else {
        fileName = 'MyAssets.zip'
    }
    const url = window.URL.createObjectURL(response.data)
    const a = document.createElement('a')
    a.href = url
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    // 清理资源
    document.body.removeChild(a)
    setTimeout(() => {
        window.URL.revokeObjectURL(url)
        if (flag) {
            window.$success('下載成功')
        }
    }, 100)
})


const indexOfFn = (url, str) => {
    if (url.indexOf('?') > -1) {
        return url + str
    } else {
        return url + str.replace(/&/, '?')
    }
}

window.$define("formattingTime", function (val) {
    let hm = 1000 * 60 * 60;
    let time = Math.floor(val / hm);
    let minute = Math.floor((val - (time * hm)) / (1000 * 60));
    let second = Math.floor((val - (time * hm) - (minute * 60 * 1000)) / 1000);
    // let millisecond = Math.floor(val - (time * hm) - (minute * 60 * 1000) - (second * 1000));
    return repairZero(time, 0) + ":" + repairZero(minute, 0) + ":" + repairZero(second, 0)
})

window.$define("tansParams", function tansParams(params) {
    let result = ''
    for (const propName of Object.keys(params)) {
        const value = params[propName];
        var part = encodeURIComponent(propName) + "=";
        if (value !== null && value !== "" && typeof (value) !== "undefined") {
            if (typeof value === 'object') {
                for (const key of Object.keys(value)) {
                    if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
                        let params = propName + '[' + key + ']';
                        var subPart = encodeURIComponent(params) + "=";
                        result += subPart + encodeURIComponent(value[key]) + "&";
                    }
                }
            } else {
                result += part + encodeURIComponent(value) + "&";
            }
        }
    }
    return result
})

window.$define("parseTime", function parseTime(time, pattern) {
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
        } else if (typeof time === 'string') {
            time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        // @ts-ignore
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
})

/**
 * @author: kxf
 * @createDate: 2023/9/13
 * @description: 获取用户头像信息
 * 入参解释:
 * 返回值解释:
 * @steps：
 */
window.$define("getUserinfo", function conditionsSatisfaction(that, fn = () => {
}) {
    that.$axios.get("/business/user").then((res) => {
        if (res.code == 200) {
            setUserInfoFn(that, {
                isLogin: true,
                ...res.data
            })
            fn();
        }
    })
})

/**
 * @author: lys
 * @createDate: 2023/10/29
 * @description:跳转被阻断的路由
 * 入参解释:
 * 返回值解释:
 * @steps：
 */
window.$define("returnTool", function (val) {
    if (vuex.state.goingJump) {
        router.push({
            path: vuex.state.goingJump
        })
        vuex.commit('setGoingJump', '');
    }
})
window.$define("authenticationLogin", (that) => {

})
const setUserToolInfoFn = (that, obj) => {
    that.$store.commit('setToolInfo', obj);
}

const setUserInfoFn = (that, obj) => {
    that.$store.commit('setUserInfo', obj);
}

// 阻断切换页面后的接口递归调用
window.$define("blockTheCycle", (that) => {
    return that.$route.path !== that.pathName;
})

const repairZero = (dou, type) => {
    dou = dou + '';
    if (type == 0) {
        return dou.length == 1 ? "0" + dou : dou;
    } else if (type == 1) {
        return dou.length == 1 ? "00" + dou : dou.length == 2 ? "0" + dou : dou;
    }
}




